import type { NLogs } from '@app/types/Logs';

export const extractHeadersForLogs: NLogs.Main = async ({
  userId,
  database,
}) => {
  try {
    const result: NLogs.Result = {
      HeaderUserId: null,
      HeaderDatabase: null,
      HeaderIsMobile: null,
      HeaderOS: null,
      HeaderIP: null,
    };

    const ua = window.navigator.userAgent.toLowerCase();
    const isMobile = ua.includes('mobile');

    const defineOS = () => {
      if (ua.includes('windows')) return 'windows';
      if (ua.includes('android')) return 'android';
      if (ua.includes('mac') || ua.includes('apple') || ua.includes('iphone'))
        return 'ios';
      if (ua.includes('linux')) return 'linux';
      return 'other';
    };

    result.HeaderUserId = userId;
    result.HeaderDatabase = database;
    result.HeaderIsMobile = isMobile ? 'true' : 'false';
    result.HeaderOS = defineOS();
    // HeaderIP остаётся null: метода GetUserInfo, который отдавал IP
    // устройства, в API больше нет (us/11114); поле оставлено, чтобы не
    // менять форму заголовков логов.

    return result;
  } catch (error) {
    // eslint-disable-next-line
    return console.log('Error of extractHeadersForLogs:', error);
  }
};
